import { isValidObject } from "./validators";

export function requestsValidation(requests, autoApprovalPolicies) {
  const consentData = [];
  const lockerSetupData = [];
  const authorizationData = [];

  const { consents, lockerSetups, authorizations } = requests;

  consents?.forEach((data) => {
    if (new Date(data?.permission?.dataEraseAt) < new Date()) {
      consentData.push({ ...data, status: "EXPIRED" });
    } else if (
      getConsentRequestStatus(data, autoApprovalPolicies) &&
      data?.status === "GRANTED"
    ) {
      consentData.push({ ...data, status: "AUTO-APPROVED" });
    } else {
      consentData.push(data);
    }
  });

  lockerSetups?.forEach((data) => {
    const { lastUpdated, hiu } = data.subscription;
    lockerSetupData.push({
      ...data,
      lastUpdated,
      hiu
    });
  });

  authorizations?.forEach((data) => {
    const { name, id } = data.requester;

    authorizationData.push({
      ...data,
      hiu: { id, name }
    });
  });

  return {
    ...requests,
    lockerSetups: lockerSetupData,
    authorizations: authorizationData,
    consents: consentData
  };
}

export function getConsentRequestStatus(request, autoApprovalPolicies) {
  if (!isValidObject(autoApprovalPolicies)) {
    return;
  }
  const autoApprovalPolicyData = Object.values(autoApprovalPolicies).find(
    (policy) => {
      const { isApplicableForAllHIPs, includedSources } = policy.data;

      if (!request?.permission?.dateRange) {
        return {};
      }
      const { from, to } = request?.permission?.dateRange;

      if (isApplicableForAllHIPs) {
        if (
          from >= includedSources[0].period.from &&
          to <= includedSources[0].period.to &&
          policy.enabled &&
          request.hip
        ) {
          return policy;
        }
      } else if (
        request?.hip &&
        includedSources?.find(
          (source) =>
            from >= source.period.from &&
            to <= source.period.to &&
            source.hip.id === request.hip
        ) &&
        policy.enabled
      ) {
        return policy;
      }
      return null;
    }
  );
  return autoApprovalPolicyData ? true : false;
}
